class Mobile {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {

    $(".item").css({
      "opacity": "0",
      "pointer-events": "none",
      "right": "-100%"
    });
    
    const _this = this;

    $(".open-modal").on("click", function (e) {
      e.stopPropagation(); // クリックイベントのバブリングを防ぐ
      $('html').addClass('is-modal');
      var targetId = $(this).attr("id").replace("open", "mobile");
      var $targetModal = $("#" + targetId);

      // すべてのモーダルを閉じる
      $(".item").css({
        "opacity": "0",
        "pointer-events": "none",
        "right": "-100%"
      });

      // クリックした要素に対応するモーダルを開く
      $targetModal.css({
        "opacity": "1",
        "pointer-events": "auto",
        "right": "0%"
      });

      // .close の right を 2rem に設定
      $targetModal.find(".close").css("right", "2rem");

      // スクロール禁止＆画面固定
      toggleScrollBan(true);
    });

    $(".close").on("click", function (e) {
      e.stopPropagation(); // バブリング防止
      const $modal = $(".item");
      closeModal($modal);
    });

    // モーダル内でホイールスクロールを制御
    $(".item").on("wheel", function (event) {
      const $this = $(this);
      const scrollTop = $this.scrollTop();
      const scrollHeight = $this.prop("scrollHeight");
      const height = $this.outerHeight();
      const delta = event.originalEvent.deltaY;

      if (
        (delta < 0 && scrollTop > 0) ||
        (delta > 0 && scrollTop + height < scrollHeight)
      ) {
        event.stopPropagation();
      } else {
        $this.scrollTop(scrollTop + delta * 0.3);
        event.preventDefault();
      }
    });
  }
}

// モーダルを閉じる関数
function closeModal($modal) {
  $modal.css({
    "opacity": "0",
    "pointer-events": "none",
    "right": "-100%"
  });

  // .close の right を -100% に変更
  $modal.find(".close").css("right", "-100%");

  if($('html').hasClass('is-modal')) {
    // スクロール再開
    toggleScrollBan(false);
  }

  $('html').removeClass('is-modal');
}

// -------------------------------------------------
// スクロール禁止・再開（位置を保持）
// -------------------------------------------------
window.scrollTopPos = 0;

function toggleScrollBan(isBan) {
  const body = document.querySelector('html');
  if (isBan) {
    if ($(window).scrollTop() != 0) {
      window.scrollTopPos = $(window).scrollTop();
    }
    
    // スクロール位置を記録
    body.style.position = 'fixed';
    body.style.top = `-${window.scrollTopPos}px`;
    body.style.width = '100%';
    body.classList.add('is-hidden');

    $("html").css({ 'top': '-' + window.scrollTopPos + 'px' }).addClass('is-active');
  } else {
    // `position: fixed` を解除
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    body.classList.remove('is-hidden');
    
    $("html").removeClass('is-active');
    
    // 保存したスクロール位置に戻す
    $(window).scrollTop(window.scrollTopPos);
  }
}

// クラスを適用してモーダルを制御
$(document).ready(function () {
  new Mobile("js-mobile");
});
